module.exports = __webpack_public_path__ + "media/images/hero/glyph-b3-a62bf72c5150d8c10b60bafd63865e9b.svg";